module.exports = __webpack_public_path__ + "static/banner-footer-update-data-co-deece3dd74077614ec61f73003db6aa2.png";